// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__a34El","content":"GlobalSearch_content__1yRRL"};